import { usePostComment } from './usePostComment'
import { CommentData } from './types'
import { useQueryClient } from '@tanstack/react-query'

export const useHandlePostComment = () => {
  const queryClient = useQueryClient()
  const { mutate: postComment } = usePostComment()

  const handlePostComment = async (commentData: CommentData) => {
    const clientId = `temp_${Date.now()}_${Math.random().toString(36).slice(2)}`
    const _pk = commentData.PK

    // optimistic add
    queryClient.setQueryData<any[]>(['commentsTable'], (prev = []) => [
      ...prev,
      { ...commentData, SK: clientId, __optimistic: true },
    ])

    await new Promise((resolve, reject) => {
      postComment(commentData, {
        onSuccess: serverRow => {
          // swap temp with server row (dedupe by SK or createdAt+PK)
          queryClient.setQueryData<any[]>(
            ['commentsTable'],
            (prev = []) =>
              prev
                .filter(r => r.SK !== clientId) // remove temp
                .concat(serverRow) // add canonical
          )
          resolve(true)
        },
        onError: err => {
          // rollback temp on error
          queryClient.setQueryData<any[]>(['commentsTable'], (prev = []) => prev.filter(r => r.SK !== clientId))
          reject(err)
        },
      })
    })
  }

  return { handlePostComment }
}
